import { useSyncExternalStore } from 'react';

const DARK_QUERY = '(prefers-color-scheme: dark)';

// This runs in the root layout, so on every route. Safari before 14 (still in
// old iOS web views) has `matchMedia` but only the legacy `addListener`, and a
// throw here would take down every page, so fall back to it; and a browser
// with no `matchMedia` at all reads as light.
function darkQuery(): MediaQueryList | null {
  return typeof window.matchMedia === 'function' ? window.matchMedia(DARK_QUERY) : null;
}

const subscribe = (cb: () => void) => {
  const mql = darkQuery();
  if (!mql) return () => {};
  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', cb);
    return () => mql.removeEventListener('change', cb);
  }
  mql.addListener(cb);
  return () => mql.removeListener(cb);
};
const getSnapshot = () => darkQuery()?.matches ?? false;
const getServerSnapshot = () => false;

/** The device's light/dark setting, updated live when the payer switches it. */
export function usePrefersDarkScheme() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
